import Vue from 'vue'
import utilFormData from '../../utils/objectToForm'

const transformer = function(tax) {
  return {
    ...tax,
    sinisters: tax.sinisters.map(s => {
      return {
        ...s,
        sinisterNumber: s.sinister_number,
      }
    })
  }
}

export default (payload) => {

  const formFile=utilFormData(payload)

  return Vue.$http.post('taxreceipt/taxreceipt/', formFile)
    .then((response) => {
      let data = transformer(response.data)
      return data
    })
}


// WEBPACK FOOTER //
// ./src/services/taxReceipt/verifyFilesTaxReceipt.js